import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import Content from "../Modulos/Prossmap/Home/Content";
import ModalNovoProssmap from "../Modulos/Prossmap/Home/ModalNovoProssmap";
import { useModal } from "../contexts/ModalContext";

const Prossmap = () => {

    const { openModal, closeModal, isModalOpen } = useModal();

    const openSidebar = () => openModal("prossmapSidebar");

    const openNovoProssmap = () => {
        closeModal();
        openModal("prossmapNovo");
    };

    return (
        <>
            <NavBar
                title="PROSSMAP"
                goBackOnePage
                setSideBar={openSidebar}
            />
            <GenericBody>
                <Content />
            </GenericBody>

            {isModalOpen("prossmapSidebar") && (
                <Overlay state changeContent={closeModal}>
                    <SideMenu>
                        <SideMenuBtn button="NOVO PROSSMAP" clickFunc={openNovoProssmap} />
                    </SideMenu>
                </Overlay>
            )}

            {isModalOpen("prossmapNovo") && <ModalNovoProssmap />}
        </>
    );
};

export default Prossmap;
